import { render, staticRenderFns } from "./yiBrand.vue?vue&type=template&id=9f2d390a&scoped=true&"
import script from "./yiBrand.vue?vue&type=script&lang=js&"
export * from "./yiBrand.vue?vue&type=script&lang=js&"
import style0 from "./yiBrand.vue?vue&type=style&index=0&id=9f2d390a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f2d390a",
  null
  
)

export default component.exports